import { render } from "./BigMenu.vue?vue&type=template&id=353ae739&scoped=true"
import script from "./BigMenu.vue?vue&type=script&lang=js"
export * from "./BigMenu.vue?vue&type=script&lang=js"

import "./BigMenu.vue?vue&type=style&index=0&id=353ae739&lang=scss&scoped=true"

import exportComponent from "/home/mmelillo/development/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353ae739"]])

export default __exports__